
export default function LoadingPage() {

    const style = {
        background: '#fff',
        color: '#000',
        display: 'flex',
        height: '100dvh',
        alignItems: 'center',
        justifyContent: 'center',

    }

    return (
        <div style={style}>
            Loading...
        </div>
    )
}